module.exports = __webpack_public_path__ + "img/Super_Star_32@2x.00d81278.png";